module.exports = __webpack_public_path__ + "static/servicesBannerIcon-f9304de9005a1ee7bc2d5a73c49f6154.png";